import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { useLocale } from "./LocaleProvider";
import { getLocale, normaliseLocale, tenantEnabledAppLocales } from "./locale-state";

/** Refine the guest locale from /me without silently swallowing load failures. */
export const AuthenticatedLocaleSync: React.FC = () => {
  const { user } = useAuth();
  const { changeLocale } = useLocale();
  const { t } = useTranslation("common");
  const [failed, setFailed] = React.useState(false);
  const [attempt, retry] = React.useReducer((value: number) => value + 1, 0);
  React.useEffect(() => {
    let current = true;
    setFailed(false);
    if (!user?.userId || !user.locale) return;
    const allowed = tenantEnabledAppLocales(user.enabledLocales);
    const saved = normaliseLocale(user.locale);
    if (!saved || !allowed.includes(saved) || saved === getLocale()) return;
    void changeLocale(saved).catch(() => { if (current) setFailed(true); });
    return () => { current = false; };
  }, [user?.userId, user?.locale, user?.enabledLocales, changeLocale, attempt]);
  if (!failed) return null;
  return (
    <div role="alert" className="shell" style={{ paddingBlock: 12 }}>
      <span>{t("sharedState.errorMessage")}</span>{" "}
      <button type="button" className="btn btn-outline btn-sm" onClick={retry}>
        {t("sharedState.retry")}
      </button>
    </div>
  );
};
